<div id="dsw" style="min-height: auto; padding-bottom: 0">
  <div class="popup-overlay"></div>
  <div class="cst-popup popup-selectdealer">
    <div class="popup-header">
      <div class="flex-center space-between">
        <h2 translate>lblChooseYourDealer</h2>
        <em class="fas fa-times close-icn-popup popup-close" (click)="activeModal.close()"></em>
      </div>
    </div>
    <div class="popup-content">
      <div class="flex-center tab-title mbt20 xsblock xsmbt10">
        <ul class="flex-center tab-st-1 tab-link">
          <li (click)="showMapSection = false">
            <a translate class="active" [ngClass]="{active: !showMapSection}" href="javascript:void(0);">lblListView</a>
          </li>
          <li (click)="showMapSection = true">
            <a translate href="javascript:void(0);" [ngClass]="{active: showMapSection}">lblShowOnMap</a>
          </li>
        </ul>
      </div>

      <div class="cst-input-field mbt20 xsmbt10" *ngIf="!showMapSection">
        <input type="text" id="txtDPostCode" class="form-control ng-pristine ng-valid ng-touched" 
          [(ngModel)]="globalSearch" (keyup)="applyNGXFilter()"
          placeholder="{{ 'lblSearchForDealer' | translate }}" />
      </div>
      <div class="car-details tab-content-listing" id="divallDealer">
        <div id="mapView" class="tab-content" *ngIf="showMapSection">
          <google-map [latitude]="latitude" [longitude]="longitude" style="height: 500px;">
            <map-marker *ngFor="let m of dealersWithLatLong"
              (click)="openWindow(m.dealerId)"
              [latitude]="m.latitude"
              [longitude]="m.longitude">
              <map-info-window>
                <div class="infoWindowContent">
                  <strong>{{m.dealerName}}</strong>
                  <br>{{m.address}}<br><br>
                  <a href="javascript:void(0);" class="a-underline" (click)="selectDealerFromMap(m)">Choose Dealer</a>
                </div>
              </map-info-window>
            </map-marker>
          </google-map>
        </div>
        <div id="listView" class="tab-content" *ngIf="!showMapSection">
          <div class="cstalldealer">
            <form [formGroup]="selectDealerData">
              <ul class="all-dealer-listing" *ngIf="allDealerDetails">
                <li *ngFor="let dealer of allDealerDetails | filterBy:dealerFilter; let i=index" class="ng-scope">
                  <label class="cst-radio">
                    <input type="radio" name="selectedDealer" [id]="i" [value]="dealer.dealerId" formControlName="selectedDealer" />
                    <span class="radioface"></span>
                    <div class="cst-distance-info" *ngIf="dealer.distance !== 0">{{dealer.distance | number:'2.2-2'}}<span>KM</span></div>
                    <div class="cst-distance-info distance-not-avail" *ngIf="dealer.distance === 0"><span>Distance Not Available</span></div>
                    <div class="car-details">
                      <h5 class="title-h3">{{dealer.dealerName}}</h5>
                      <p>{{dealer.address}}, {{dealer.city}} - {{dealer.pincode}}</p>
                      <p translate class="mtp5 clrblue">
                        lblNextAvailable <strong>: {{dealer.nextAvailableDate | date:'shortDate'}}</strong>
                      </p>
                      <p class="font16 mtp5" [ngClass]="{'clrred': dealer.notAvailableServices?.length > 0, 'clrgreen': !dealer.notAvailableServices}">
                        <span translate *ngIf="!dealer.notAvailableServices">
                          lblThisDealerCarriesOutAllSelectedServices
                        </span>
                        <span translate *ngIf="dealer.notAvailableServices?.length > 0">
                          <span translate>lblThe</span> <strong>{{dealer.notAvailableServices}}</strong> <span translate>lblFacilityIsUnavailableWithThisDealer</span>
                        </span>
                      </p>
                      <p>
                        <span translate *ngIf="customerPickupDropOffServiceSelection">
                          <span translate style="color: #007600;" *ngIf="dealer.isVehiclePickUpAndDropOffService;">
                            lblThisDealerCarriesOutPickUpAndDropffService
                          </span>
                          <span translate style="color: #e74537;" *ngIf="!dealer.isVehiclePickUpAndDropOffService;">
                            lblPickUpAndDropffServiceNotAvailableWithToDealer
                          </span>
                        </span>
                      </p>
                    </div>
                  </label>
                </li>
              </ul>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="popup-footer text-right">
      <div class="btn-grp" *ngIf="!showMapSection">
        <button translate class="btn btn-primary" type="button" aria-label="Center Align" [disabled]="!selectDealerData.valid" (click)="closeDealerListModel()">
          lblSelectDealer
        </button>
      </div>
    </div>
  </div>
</div>
